import React from "react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";

const DeclineButtonWithLabel = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.delete}
      label={formatMessage({ id: "common.decline" })}
      iconName="clear"
      {...props}
    />
  );
};

export default DeclineButtonWithLabel;
